import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import { t, tn } from '@owl-nest/localize'
import { BREAKPOINTS, glyphs, Link, styles as S } from '@ulule/owl-kit-components/next'
import * as model from '@owl-nest/models'

import { Project } from '../../../../models/project'
import { RootState } from '../../../../../reducers'

type AboutOwnerProps = {}

const AboutOwnerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 23px;
  text-align: center;
  width: 305px;

  ${S.image.Avatar}, ${S.heading.XS} {
    cursor: pointer;
  }

  @media screen and ${BREAKPOINTS.LAPTOP} {
    align-items: center;
    margin: 0px;
    margin-bottom: 27px;
    flex-direction: row;
    text-align: left;
    width: auto;
  }
`

const AboutContentWrapper = styled.div`
  ${S.copy.M.light} {
    margin-top: 15px;
  }

  @media screen and ${BREAKPOINTS.LAPTOP} {
    margin-left: 24px;

    ${S.copy.M.light} {
      margin-top: 5px;
    }
  }
`

const City = styled(S.copy.S.regular)`
  ${Link} {
    justify-content: center;

    @media screen and ${BREAKPOINTS.LAPTOP} {
      justify-content: normal;
    }
  }
`

export function AboutOwner(): React.ReactElement<AboutOwnerProps> {
  const project = Redux.useSelector<RootState, Project>((state) => state.application.project.data)
  const ownerSupportedCount = project.owner.stats?.supported_projects_count
  const ownerOnlineCount = project.owner.stats?.created_projects_online_count
  const ownerUrl = project.owner.absolute_url

  const launchedProjectsLabel =
    ownerOnlineCount === 1
      ? t('First project launched on Ulule')
      : t('%(ownerOnlineCount)s projects launched on Ulule', {
          ownerOnlineCount,
        })
  const backedProjectsLabel = tn(
    '%(ownerSupportedCount)s project backed',
    '%(ownerSupportedCount)s projects backed',
    ownerSupportedCount,
    {
      ownerSupportedCount,
    },
  )

  return (
    <AboutOwnerWrapper>
      <a href={ownerUrl}>
        <S.image.Avatar src={model.user.avatar(project.owner, '180x180')} type="large" />
      </a>

      <AboutContentWrapper>
        <Link href={ownerUrl}>
          <S.heading.XS>{model.user.username(project.owner)}</S.heading.XS>
        </Link>

        {project.owner.location && (
          <City>
            <Link kind="secondary" withIcon>
              <glyphs.stroke.MapCursor size={16} /> {project.owner.location}
            </Link>
          </City>
        )}

        <S.copy.M.light>
          {launchedProjectsLabel}
          {ownerSupportedCount >= 1 && <> {` - ${backedProjectsLabel}`} </>}
        </S.copy.M.light>
      </AboutContentWrapper>
    </AboutOwnerWrapper>
  )
}
